import { memo } from 'react'
import { shallowEqual } from 'react-redux'

import { RenderWhen } from 'clickNgo/components/renderWhen'
import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'

import { partnerContactsTranslation } from '../../translation'

import styles from './ContactControls.module.scss'

interface IProps {
  numberOfSelectedContacts: number
  numberOfExpandedContacts: number
  numberOfFilteredContacts: number
  onCollapseContacts: () => void
  onCreateContact: () => void
  onExportContacts: () => void
  onExportSelectedContacts: () => void
  onEditContact: () => void
  onSearchQueryChange: (query: string) => void
  isReadOnly?: boolean
}

export const ContactControls = memo<IProps>(
  ({
    numberOfExpandedContacts,
    numberOfFilteredContacts,
    numberOfSelectedContacts,
    onCollapseContacts,
    onCreateContact,
    onExportContacts,
    onExportSelectedContacts,
    onEditContact,
    isReadOnly,
  }) => {
    const isExportVisible = numberOfFilteredContacts > 0

    const isExportSelectedContactVisible =
      numberOfSelectedContacts > 0 && numberOfSelectedContacts !== numberOfFilteredContacts

    return (
      <div className={styles.controls}>
        <div className={styles.actions}>
          <RenderWhen condition={!isReadOnly}>
            <Button
              onClick={onCreateContact}
              icon="kbase kbase-add"
              color="grey"
              variant="text"
              className={styles.actionBtn}
            >
              <Translation text={partnerContactsTranslation.contacts.controls.actions.add} span />
            </Button>
          </RenderWhen>
          <RenderWhen condition={isExportVisible}>
            <Button
              icon="kbase kbase-download"
              color="grey"
              variant="text"
              className={styles.actionBtn}
              onClick={onExportContacts}
            >
              <Translation
                text={partnerContactsTranslation.contacts.controls.actions.export}
                span
              />
              <RenderWhen condition={numberOfFilteredContacts > 1}>
                {' '}
                ({numberOfFilteredContacts})
              </RenderWhen>
            </Button>
          </RenderWhen>
          <RenderWhen condition={isExportSelectedContactVisible}>
            <Button
              icon="kbase kbase-delete"
              color="grey"
              variant="text"
              className={styles.actionBtn}
              onClick={onExportSelectedContacts}
            >
              <Translation
                text={partnerContactsTranslation.contacts.controls.actions.exportSelected}
                span
              />{' '}
              ({numberOfSelectedContacts})
            </Button>
          </RenderWhen>
          <RenderWhen condition={numberOfSelectedContacts === 1}>
            <Button
              icon="kbase kbase-edit"
              color="grey"
              variant="text"
              className={styles.actionBtn}
              onClick={onEditContact}
            >
              <Translation text={partnerContactsTranslation.contacts.controls.actions.edit} span />
            </Button>
          </RenderWhen>
          <RenderWhen condition={numberOfExpandedContacts > 0}>
            <Button
              icon="kbase kbase-compress"
              color="grey"
              variant="text"
              className={styles.actionBtn}
              onClick={onCollapseContacts}
            >
              <Translation
                text={partnerContactsTranslation.contacts.controls.actions.collapse}
                span
              />{' '}
              ({numberOfExpandedContacts})
            </Button>
          </RenderWhen>
        </div>
      </div>
    )
  },
  shallowEqual
)
